import {Box, makeStyles, Typography} from "@material-ui/core"
import {SwiperSlide} from "swiper/react"

import "swiper/swiper.min.css"
import "swiper/swiper-bundle.css"
import "swiper/components/pagination/pagination.min.css"
import "swiper/components/navigation/navigation.min.css"
import "swiper/components/thumbs/thumbs.min.css"

const useStyles = makeStyles({
	root: {
		maxWidth: 300,
		margin: "0 auto",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		padding: 16,
		cursor:"grab"
	},
})

const Slides = ({image, title, text}) => {
	const classes = useStyles()
	return (
		<Box className={classes.root}>
			<img width='75px' height='75px' src={image} alt={title} />
			<Typography
				variant='h6'
				style={{textAlign: "center", fontSize: 16, marginTop: 16}}>
				{title}
			</Typography>
			<Typography
				variant='subtitle1'
				style={{ fontSize: 12, marginTop: 8}}>
				{text}
			</Typography>
		</Box>
	)
}

export default Slides
